export const styles = {
  container: {
    cursor: 'pointer',
    overflow: 'visible',
    position: 'absolute',
    top: '0%',
    right: '20px',
  },
  modal: {
    position: 'absolute',
    width: '220px',
    height: 'auto',
    padding: '1rem',
    zIndex: '999',
    top: '-250%',
    left: '105%',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 16px 0px #2737541a',
    display: 'flex',
    alignItems: 'flex-start',
    color: '#4f5b94',
  },
  logo: {
    marginRight: '10px',
  },
  modalLeft: {
    position: 'absolute',
    width: '220px',
    height: 'auto',
    padding: '1rem',
    zIndex: '10999',
    top: '-250%',
    right: '115%',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 16px 0px #2737541a',
    display: 'flex',
    alignItems: 'flex-start',
    color: '#4f5b94',
  },
}
